import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { v4 as uuid } from 'uuid';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export enum NotificationType {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info'
}

export interface Notification {
  id?: String;
  message: String;
  type: NotificationType;
  isLoading: Boolean;
}

@Injectable()
export class NotificationService {
  showNotificaticationEvent: EventEmitter<Notification> = new EventEmitter();
  closeNotificationEvent: EventEmitter<String> = new EventEmitter();
  changeStatusEvent: EventEmitter<Object> = new EventEmitter();
  stopLoadingEvent: EventEmitter<Object> = new EventEmitter();
  endProgressEvent: EventEmitter<Object> = new EventEmitter();
  showDuplicateDocsEvent: EventEmitter<any> = new EventEmitter();
  notificationID = [];
  timestamp = new Date().getTime();

  backendErrorNotificationIDs = [];

  constructor() { }

  public closeNotification(id: String) {
    this.closeNotificationEvent.emit(id);
  }

  public showNotification(notification: Notification): String {
    if (notification.isLoading) {
      this.notificationID.shift();
    }
    const id = uuid();
    notification.id = id;
    this.showNotificaticationEvent.emit(notification);
    return id;
  }

  public changeStatus(id: String, type: NotificationType, message: String) {
    this.changeStatusEvent.emit({
      id: id,
      type: type,
      message: message
    });
  }

  public stopLoading(id: String, type: NotificationType, message: String) {
    this.stopLoadingEvent.emit({
      id: id,
      type: type,
      message: message
    });
  }
}

@Injectable()
export class NotificationAPIService {
  timestamp = new Date().getTime();
  showDeploymentNotificaticationEvent: EventEmitter<any> = new EventEmitter();
  
  notificationSubscriber;

  constructor(private http: HttpClient) { }

  getPushNotification(filter): Observable<any> {
    const query = '';
    const url = environment.communication_service_api + 'notifications/get_push_notifications?timestamp=' + this.timestamp;
    return this.http.get(url).pipe(
      map((response: Array<Object>) => {

        if (response['deployment']) {
          this.showDeploymentNotificaticationEvent.emit(response['deployment']);
        }

        if (response['notification'].length > 0) {
          this.timestamp = response[response.length - 1]['timestamp'];
        }
        return response;
      }),
      catchError(err => of(null))
    );
  }

  // getNotificationsList(offset, limmit): Observable<any> {
  //   const query = '';
  //   const url = environment.communication_service_api + `notifications/list_notifications?limmit=${limmit}&offset=${offset}`;
  //   return this.http.get(url).map((response: Array<Object>) => {
  //     return response;
  //   });
  // }
  getNotificationsList(offset, limmit): Observable<any> {
    const query = '';
    const url = environment.communication_service_api + `notifications/list_notifications?limmit=${limmit}&offset=${offset}`;
    return this.http.get(url)
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  // markAsRead(notification_id): Observable<any> {
  //   const url = environment.communication_service_api + 'notifications/mark_read/' + notification_id;
  //   return this.http.post(url, {}).map((response: Array<Object>) => {
  //     return response;
  //   });
  // }
  markAsRead(notification_id): Observable<any> {
    const url = environment.communication_service_api + 'notifications/mark_read/' + notification_id;
    return this.http.post(url, {})
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  // clearNotifications(id = null): Observable<any> {
  //   let url = environment.communication_service_api + 'notifications/clear';
  //   if (id) {
  //     url += '?id=' + id;
  //   }
  //   return this.http.delete(url, {}).map((response: Array<Object>) => {
  //     return response;
  //   });
  // }
  clearNotifications(id = null): Observable<any> {
    let url = environment.communication_service_api + 'notifications/clear';
    if (id) {
      url += '?id=' + id;
    }
    return this.http.delete(url, {})
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }
}
